module.exports = __webpack_public_path__ + "img/02_sc.270c4aa7.png";